import { Mods, classNames } from 'src/shared/lib/helpers/classNames';
import cls from './HeroCell.module.scss';

interface IHeroCell {
  name: string;
  img: string;
  isActive: boolean
}

export const HeroCell = ({ name, img, isActive }: IHeroCell) => {
  const mods: Mods = {
    [cls.isActive]: isActive
  };

  return (
    <div className={cls.heroCell}>
      <div className={cls.heroCell__frame}>
        <span className={cls.heroCell__bg} />
        <span className={cls.heroCell__img}>
          <img src={img} alt={img} className={classNames('', mods)} />
        </span>
      </div>
      <span className={cls.heroCell__name}>{name}</span>
    </div>
  );
};
